module.exports = __webpack_public_path__ + "static/media/fistFlexed.5450b8d4.png";